// extracted by mini-css-extract-plugin
module.exports = {"privacyTable":"privacy_privacyTable__10-Y8"};